import { effect, inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';

import { TranslateService } from '@ngx-translate/core';
import { SntI18nService } from '@senet-uiverse/i18n';

import BASE from '../../app.base';

@Injectable({ providedIn: 'root' })
export class TitleService {
  private readonly translateService = inject(TranslateService);
  private readonly title = inject(Title);

  private readonly currentLanguage = toSignal(inject(SntI18nService).getCurrentLanguage());
  private readonly titleKey = signal('');

  constructor() {
    effect(() => {
      this.currentLanguage();

      let title: string = BASE.title;

      if (this.titleKey()) {
        title += `: ${this.translateService.instant(this.titleKey())}`;
      }

      this.title.setTitle(title);
    });
  }

  change(key: Readonly<string>) {
    this.titleKey.set(key);
  }
}
